interface Icon {
  color?: 'blue' | 'dark-blue' | 'dark-gray' | 'gray' | 'red' | 'tan';
  position: 'bottom' | 'left' | 'right';
  type: 'text' | 'fa' | 'default';
}

// Icons config
// N.B. Sorted alphabetically!
export const iconsConfig: Record<string, Icon> = {
  audio: {
    position: 'right',
    type: 'default',
  },
  awkwardQuestions: {
    color: 'dark-blue',
    type: 'text',
    position: 'bottom',
  },
  bloomberg: {
    type: 'text',
    position: 'left',
  },
  breakingNews: {
    color: 'red',
    position: 'bottom',
    type: 'text',
  },
  career: {
    color: 'tan',
    position: 'bottom',
    type: 'text',
  },
  detector: {
    color: 'blue',
    position: 'bottom',
    type: 'text',
  },
  detectorCategory: {
    position: 'right',
    type: 'text',
  },
  economist: {
    position: 'left',
    type: 'default',
  },
  everydayHeroes: {
    color: 'dark-blue',
    position: 'bottom',
    type: 'text',
  },
  exclusive: {
    color: 'blue',
    position: 'bottom',
    type: 'text',
  },
  gallery: {
    position: 'right',
    type: 'default',
  },
  graph: {
    position: 'right',
    type: 'default',
  },
  important: {
    color: 'blue',
    position: 'bottom',
    type: 'text',
  },
  interview: {
    color: 'blue',
    position: 'bottom',
    type: 'text',
  },
  invest: {
    position: 'left',
    type: 'text',
  },
  politicalAd: {
    color: 'gray',
    position: 'bottom',
    type: 'text',
  },
  premiere: {
    color: 'blue',
    position: 'bottom',
    type: 'text',
  },
  pressRelease: {
    color: 'gray',
    position: 'bottom',
    type: 'text',
  },
  renew: {
    color: 'blue',
    position: 'bottom',
    type: 'text',
  },
  research: {
    color: 'blue',
    position: 'bottom',
    type: 'text',
  },
  specialProject: {
    color: 'blue',
    position: 'bottom',
    type: 'text',
  },
  sponsoredContent: {
    color: 'gray',
    position: 'bottom',
    type: 'text',
  },
  stream: {
    color: 'red',
    position: 'bottom',
    type: 'text',
  },
  streamSoon: {
    color: 'blue',
    position: 'bottom',
    type: 'text',
  },
  sustainableCourse: {
    color: 'dark-gray',
    position: 'bottom',
    type: 'text',
  },
  test: {
    color: 'blue',
    position: 'bottom',
    type: 'text',
  },
  video: {
    position: 'right',
    type: 'default',
  },
};

// Icon name => SVG icon mapping
export const iconList = {
  audio: 'microphone',
  gallery: 'gallery',
  trending: 'trending',
  video: 'play',
};

// Career channel used icon from Delfi 2.0 CMS
export const careerIcons = [
  'frontPageMostPopularJobOffers',
  'frontPageLookingForTalents',
  'frontPageInterviewWithCLevelManagers',
  'frontPageRelevantInTheOffice',
  'frontPageItsInteresting',
  'frontPageHHRPerspective',
];

// Career channel used icons from Delfi 1.0 CMS
export const careerTags = [89580921, 89580923, 89580941, 89580979, 89580981, 89969303];

// Lie detector project categories
export const detectorCategories = [
  85827865, 79451385, 79451419, 85827867, 88121525, 88122145, 92718855, 92719795, 93953369, 93953457, 93481599, 92782775, 85827871, 79451335,
];

// Political Ads articles categories
export const politicalAdCategories = [84666519, 85038351, 80167949, 91841171];
